import {Avatar, Table, TableBody, TableCell, TableHead, TableRow} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {stylesheet} from "typestyle";
import {CubeOrder} from "../types";
import {CustomerDisplay} from "./customer";
import {OrderDisplay, OrderStatus} from "./order";
import {useLocalization} from "../../i18n";

interface OrderTableProps {
    orders: CubeOrder[];
    onClick: (order: CubeOrder) => void;
}

export function OrderTable({orders, onClick}: OrderTableProps) {
    const {t} = useLocalization();
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{t("Order")}</TableCell>
                    <TableCell>{t("Customer")}</TableCell>
                    <TableCell>{t("Status")}</TableCell>
                    <TableCell>{t("Box")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {orders.map(order => (
                    <OrderRow key={order.order.id}
                              cubeOrder={order}
                              onClick={onClick}/>
                ))}
            </TableBody>
        </Table>
    );
}

interface DeliveryOrderRowProps {
    cubeOrder: CubeOrder;
    onClick: (order: CubeOrder) => void;
}

function OrderRow({cubeOrder, onClick}: DeliveryOrderRowProps) {
    const {order, occupancy} = cubeOrder;
    const handleClick = useCallback(() => onClick(cubeOrder), [onClick, cubeOrder]);
    return (
        <TableRow onClick={handleClick}>
            <TableCell>
                <OrderDisplay order={order}/>
            </TableCell>
            <TableCell>
                <CustomerDisplay customer={order.customer} maxLines={2} />
            </TableCell>
            <TableCell>
                <OrderStatus status={order.orderState}/>
            </TableCell>
            <TableCell>
                {occupancy && (
                    <div className={styles.boxNumber}>
                        <Avatar size={1.5}>{occupancy.boxNumber}</Avatar>
                    </div>
                )}
            </TableCell>
        </TableRow>
    );
}

const styles = stylesheet({
    boxNumber: {
        marginRight: "1em"
    }
});